import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  header: {
    marginBottom: 0,
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '1.6rem',
    marginBottom: '9.6rem',
  },
  continueButtonsWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '1.6rem',
  },
  actionButton: {
    padding: 0,
  },
  attributesProgressStatus: {
    fontSize: '1.8rem',
    lineHeight: '2.4rem',
    textAlign: 'center',
    marginBottom: '6rem',
    color: colors.neutral[900],
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
